import { Tag } from "antd";
import { FC } from "react";
import "./index.css";

export type TaskPriority = "low" | "medium" | "high" | "urgent";

export const TASK_PRIORITY_LABELS: Record<TaskPriority, string> = {
  low: "低优先级",
  medium: "中优先级",
  high: "高优先级",
  urgent: "紧急",
};

interface TaskPriorityTagProps {
  priority?: TaskPriority;
}

const TaskPriorityTag: FC<TaskPriorityTagProps> = ({
  priority = "medium",
}) => (
  <Tag className={`taskPriorityTag taskPriorityTag--${priority}`}>
    {TASK_PRIORITY_LABELS[priority]}
  </Tag>
);

export default TaskPriorityTag;
